import { useState } from "react"
import { Stack, TextField, Button, FormHelperText } from "@mui/material"
import { styled } from "@mui/material/styles"

const TinyButton = styled(Button)`
  font-size: 12px;
`

export const PasswordInput = (props: any) => {
  const [showPassword, setShowPassword] = useState(false)

  const handleShowPassword = () => {
    setShowPassword(!showPassword)
  }

  return (
    <>
      {props.hint ? (
        <>
          {props.formlabel}
          <Stack
            justifyContent={"space-between"}
            direction={"row"}
            alignItems={"center"}
          >
            <FormHelperText> {props.hint}</FormHelperText>
            <TinyButton size="small" onClick={handleShowPassword} disableRipple>
              {showPassword ? "Hide password" : "Show password"}
            </TinyButton>
          </Stack>
        </>
      ) : (
        <Stack
          justifyContent={"space-between"}
          direction={"row"}
          alignItems={"center"}
        >
          {props.formlabel}
          <TinyButton size="small" onClick={handleShowPassword} disableRipple>
            {showPassword ? "Hide password" : "Show password"}
          </TinyButton>
        </Stack>
      )}

      <TextField
        type={showPassword ? "text" : "password"}
        autoComplete={"false"}
        {...props}
      />
    </>
  )
}

export default PasswordInput
